import React, { forwardRef } from 'react';

import { type ElementProps, Trigger } from '@pkg/components';
import { useTooltipContext } from '@pkg/components/Elements/Tooltip/hooks';
export const TooltipTrigger = forwardRef<HTMLElement, ElementProps>(function TooltipTrigger({ children }, propRef) {
    const context = useTooltipContext();
    return (
        <Trigger ref={propRef} context={context}>
            {children}
        </Trigger>
    );
});
